import type { AppLanguage } from './types';
import { getCatalog, type MessageKey } from './messages';

export type TranslateParams = Record<string, string | number>;

function interpolate(template: string, params?: TranslateParams): string {
  if (!params) {
    return template;
  }
  return template.replace(/\{(\w+)\}/g, (_, key: string) => {
    const value = params[key];
    return value === undefined ? `{${key}}` : String(value);
  });
}

export function getMessageTemplate(language: AppLanguage, key: MessageKey): string {
  const catalog = getCatalog(language);
  return catalog[key] ?? getCatalog('en')[key] ?? key;
}

export function translate(
  language: AppLanguage,
  key: MessageKey,
  params?: TranslateParams,
): string {
  return interpolate(getMessageTemplate(language, key), params);
}
